const appConfig = {
  app: {
    imageServiceDomain: "https://suarte.art/cdn-cgi/imagedelivery/hAeIC__6Aj746x0RFU1joA",
    shareGatewayBaseUrl: process.env.REACT_APP_SHARE_GATEWAY_BASE_URL || "",
    audioServiceDomain: "https://audio.files.suarte.art",
    verification_code_resend_in: 60000, // 60 seconds
    gTagId: process.env.REACT_APP_GTAG_ID || "",
  }
};

export default appConfig;
